module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/gallery/gallery10-b6747a3b9cee0e3458adb79b6730616b.jpg";